import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  MonthlyBillHeaderRoot: {
    paddingTop: 25,
  },
  title: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 24,
  },
  subTitle: {
    fontSize: 24,
    ...Fonts.type.bold,
  },
});
